<div class="container">
    <div class="row g-3">
        <div class="col-12">
            <input type="text" class="form-control" (change)="useCode(usCode)" #usCode>
        </div>
        <div class="col-12">
            <h1>ไอเทม</h1>
        </div>
        <div class="col-xl-4 col-lg-6 col-12" *ngFor="let items of itemRewardBox">
            <div class="card cardItem">
                <div class="reward">
                    <div class="reward-left">
                        <div class="logo">
                            <img src="{{items.Image}}">
                        </div>
                    </div>
                    <div class="reward-right">
                        <h1 *ngIf="items.ItemType =='discount'">ส่วนลด</h1>
                        <span *ngIf="items.DisType == 'amount' && items.ItemType =='discount'"><span
                                class="amount">{{items.DisAmount}}</span> บาท
                        </span>
                        <span *ngIf="items.DisType == 'percentage' && items.ItemType =='discount'"><span
                                class="amount">{{items.DisAmount}}</span> %
                        </span>
                        <h1 *ngIf="items.ItemType =='things'">รางวัล</h1>
                        <span *ngIf="items.ItemType =='things'"><span class="amount">{{items.ItemName}}</span>
                        </span>
                        <button class="btn btn-primary" *ngIf="items.Action == 'false'" (click)="itemUsed(items)">รับ
                            CODE</button>
                        <span *ngIf="items.Action == 'used'" class="text-success">ใช้แล้ว 23/10/2024</span>
                        <span *ngIf="items.Action == 'code'" class="text-success">CODE: {{items.ItemCode}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>